module.exports = __webpack_public_path__ + "static/img/app.3c1733b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile/app.jpg
// module id = RUmV
// module chunks = 1